// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3fhx0","alertIcon":"ConfirmModal_alertIcon__3SGb-"};